import type { ReactNode } from 'react';
import { Modal } from 'antd';

interface ConfirmDialogProps {
  open: boolean;
  title: ReactNode;
  content?: ReactNode;
  okText?: string;
  cancelText?: string;
  danger?: boolean;
  confirmLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Controlled confirmation dialog for destructive/irreversible actions (e.g. deactivating a user). */
export default function ConfirmDialog({
  open,
  title,
  content,
  okText = 'تأیید',
  cancelText = 'انصراف',
  danger = false,
  confirmLoading = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <Modal
      open={open}
      title={title}
      okText={okText}
      cancelText={cancelText}
      okButtonProps={{ danger }}
      confirmLoading={confirmLoading}
      onOk={onConfirm}
      onCancel={onCancel}
      destroyOnHidden
    >
      {content}
    </Modal>
  );
}
